module.exports = __webpack_public_path__ + "img/qr-app.fc9a161e.png";